import React, { useState } from 'react'

import './Diretoria.css'

const Diretoria = () => {
  const [showImageModal, setShowImageModal] = useState(false)
  const imageSrc = '/assets/diretoria-asjf.png'

  return (
    <div className="diretoriaPage">
      <main className="diretoriaContent">
        <section className="diretoriaHeader">
          <div className="diretoriaInfo">
            <span>Diretoria</span>
            <h1>Conheça nossa equipe de liderança</h1>
            <p>
              Aqui estão os membros da diretoria da ASJF, com fotos e descrições curtas para destacar suas funções e contribuição à nossa comunidade.
            </p>
          </div>
          <div className="diretoriaPhotoCard">
            <button
              type="button"
              className="diretoriaPhotoLink"
              onClick={() => setShowImageModal(true)}
              aria-label="Abrir imagem da diretoria em tamanho real"
            >
              <img
                className="diretoriaPhoto"
                src={imageSrc}
                alt="Foto da diretoria ASJF"
              />
            </button>
          </div>
        </section>

        <section className="diretoriaGrid">
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Presidente da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Presidente</h3>
              <p>Responsável por liderar a associação e representar os interesses da comunidade surda em Juiz de Fora.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Vice-Presidente da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Vice-Presidente</h3>
              <p>Auxilia a gestão geral da ASJF e supervisiona projetos sociais e culturais.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Diretor Administrativo da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Diretor Administrativo</h3>
              <p>Organiza as reuniões e mantém a documentação da diretoria sempre atualizada.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Diretor Financeiro da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Diretor Financeiro</h3>
              <p>Cuida dos recursos financeiros e assegura a transparência nos registros contábeis.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Diretor Sócio-Cultural da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Diretor Sócio-Cultural</h3>
              <p>Coordena atividades sociais e culturais, promovendo a integração e o engajamento da comunidade surda.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Diretor Esportivo da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Diretor Esportivo</h3>
              <p>Coordena atividades esportivas e promove o engajamento da comunidade surda em eventos e competições.</p>
            </div>
          </article>
          <article className="diretoriaCard">
            <img className="diretoriaMiniPhoto" src={imageSrc} alt="Diretor Esportivo da ASJF" />
            <div className="diretoriaCardContent">
              <h3>Conselheiro Deliberativo</h3>
              <p>Coordena e fiscaliza as atividades administrativas da ASJF.</p>
            </div>
          </article>
        </section>
      </main>

      {showImageModal && (
        <div className="imageModalOverlay" onClick={() => setShowImageModal(false)}>
          <div className="imageModalContent" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="imageModalClose"
              onClick={() => setShowImageModal(false)}
              aria-label="Fechar visualização da imagem"
            >
              ×
            </button>
            <img className="imageModalPhoto" src={imageSrc} alt="Diretoria ASJF em tamanho real" />
          </div>
        </div>
      )}
    </div>
  )
}

export default Diretoria